export default {
    namespace: 'About',
    translations: {
        zh: {
            hero: {
                kicker: 'About Us',
                title: '未来世界',
                subtitle: 'ミライワールド / FUTURE WORLD',
                description: '是一家覆盖数字化人才、中日人工智能社区运营、科技出海一站式服务、智能医疗器械和智能健康硬件产品五大业务板块为一体的全球化科技集团。'
            },
            placeholders: {
                hero: '关于我们主视觉图片占位',
                president: '社长照片占位'
            },
            company: {
                subtitle: 'Company',
                title: '公司介绍',
                cardTitle: '全球化科技集团',
                description: '未来世界（ミライワールド，FUTURE WORLD）是一家覆盖数字化人才、中日人工智能社区运营、科技出海一站式服务、智能医疗器械和智能健康硬件产品五大业务板块为一体的全球化科技集团。'
            },
            business: {
                label: 'BUSINESS',
                items: [
                    '数字化人才',
                    '中日人工智能社区运营',
                    '科技出海一站式服务',
                    '智能医疗器械',
                    '智能健康硬件产品'
                ]
            },
            strengths: {
                sectionLabel: 'TEAM & STRENGTH',
                sectionTitle: '核心团队与海外市场经验',
                marketLabel: 'MARKET FOOTPRINT',
                marketTitle: '以团队资源和长期实战经验支撑跨境落地',
                stats: [
                    { value: '10+', label: '全球市场经验' },
                    { value: '100+', label: '服务合作伙伴' },
                    { value: '1000+', label: '海外科技合作案例' },
                    { value: '100+', label: '标准化服务模块' }
                ]
            },
            philosophy: {
                label: 'PHILOSOPHY',
                title: '经营理念',
                headline: 'AI-Solve：智能驱动的未来解决方案',
                formula: 'AI = AGI + Embedded Intelligence',
                description: '我们以「通用人工智能」与「具身智能」为核心，通过技术融合创造突破性价值。',
                solveItems: [
                    { key: 'S', title: 'Speed', desc: '以敏捷响应应对技术变革' },
                    { key: 'O', title: 'Opportunity', desc: '为人才与企业构建双向机遇平台' },
                    { key: 'L', title: 'Link', desc: '建立全球科技生态的连接' },
                    { key: 'V', title: 'Value', desc: '通过精准匹配实现多维价值增值' },
                    { key: 'E', title: 'Experience & Excellence', desc: '追求极致的服务体验与专业卓越' }
                ]
            },
            mission: {
                label: 'MISSION',
                title: '使命',
                quote: '“让科技人才找到理想工作，让企业找到合适人才”',
                items: [
                    '为顶尖科技人才提供实现职业理想的全球化舞台',
                    '助力企业高效获取驱动创新的核心人才资产',
                    '构建人才与企业共同成长的可持续科技生态'
                ]
            },
            vision: {
                label: 'VISION',
                title: '愿景',
                quote: '“成为定义数字科技人才平台标准的全球领导者”'
            },
            values: {
                label: 'VALUES',
                title: '价值观',
                items: ['聚力', '专注', '创新', '卓越', '共赢']
            },
            greeting: {
                label: 'MESSAGE',
                title: '社长寄语',
                paragraph1: '全世界老龄化正在迅速加剧，许多海外国家和地区都面临人口结构变化与社会服务升级的挑战。当前，针对人口减少、少子老龄化等社会课题，我们正在通过运用 IoT 和人工智能等技术，推动由第四次产业革命带来的范式转变。学生时代在研究室中，我学习了与人工智能相关的知识。同时，也在多国籍同学共同生活的环境中，积累了跨文化体验，学习了如何建立人与人之间的信任关系，并培养了国际化视野。',
                paragraph2: '在中国，有一句话叫“以人为本，人尽其才”。人是公司最大的财富，因此，我们的经营理念就是汇聚人才、激发人才潜能、创造人的价值。',
                paragraph3: '我们将以海外市场拓展为起点，持续构建具有国际影响力的人工智能社区，并将其推广到全世界。通过人工智能社区所创造出来的人工智能技术，也将持续为社会和企业作出贡献。'
            },
            contact: {
                label: 'CONTACT',
                title: '联系信息',
                officeLabel: '东京办公室',
                officeAddress: '東京都北区田端新町3－７－６　中田第3ビルB1F',
                phoneLabel: '电话',
                phone: '080-9981-0852',
                emailLabel: '邮箱',
                email: 'contact@fw-robot.com',
                personLabel: '联系人',
                person: '@李增达',
                copyright: 'Copyright 2025 - 株式会社日本ミライワールド All Rights Reserved.'
            }
        },
        en: {
            hero: {
                kicker: 'About Us',
                title: 'FUTURE WORLD',
                subtitle: 'ミライワールド / FUTURE WORLD',
                description: 'A global technology group spanning five business segments: digital talent, China-Japan AI community operations, one-stop global expansion services for technology, intelligent medical devices, and smart health hardware products.'
            },
            placeholders: {
                hero: 'About page hero image placeholder',
                president: 'President portrait placeholder'
            },
            company: {
                subtitle: 'Company',
                title: 'Company Overview',
                cardTitle: 'Global Technology Group',
                description: 'Future World (ミライワールド, FUTURE WORLD) is a global technology group integrating five business segments: digital talent, China-Japan AI community operations, one-stop global expansion services for technology, intelligent medical devices, and smart health hardware products.'
            },
            business: {
                label: 'BUSINESS',
                items: [
                    'Digital Talent',
                    'China-Japan AI Community Operations',
                    'One-stop Global Expansion Services for Technology',
                    'Intelligent Medical Devices',
                    'Smart Health Hardware Products'
                ]
            },
            strengths: {
                sectionLabel: 'TEAM & STRENGTH',
                sectionTitle: 'Core Team And Overseas Market Experience',
                marketLabel: 'MARKET FOOTPRINT',
                marketTitle: 'Supporting cross-border execution with team resources and long-term hands-on experience',
                stats: [
                    { value: '10+', label: 'Global market experience' },
                    { value: '100+', label: 'Service partners' },
                    { value: '1000+', label: 'Overseas tech collaboration cases' },
                    { value: '100+', label: 'Standardized service modules' }
                ]
            },
            philosophy: {
                label: 'PHILOSOPHY',
                title: 'Philosophy',
                headline: 'AI-Solve: Smart-Driven Future Solutions',
                formula: 'AI = AGI + Embedded Intelligence',
                description: 'With Artificial General Intelligence and Embodied Intelligence at the core, we create breakthrough value through technological integration.',
                solveItems: [
                    { key: 'S', title: 'Speed', desc: 'Respond to technological change with agility' },
                    { key: 'O', title: 'Opportunity', desc: 'Build a two-way opportunity platform for talent and enterprises' },
                    { key: 'L', title: 'Link', desc: 'Connect the global technology ecosystem' },
                    { key: 'V', title: 'Value', desc: 'Create multidimensional value growth through precise matching' },
                    { key: 'E', title: 'Experience & Excellence', desc: 'Pursue exceptional service experience and professional excellence' }
                ]
            },
            mission: {
                label: 'MISSION',
                title: 'Mission',
                quote: '"Helping technology talent find ideal jobs, and helping enterprises find the right talent"',
                items: [
                    'Provide top technology talent with a global stage to realize their career aspirations',
                    'Help enterprises efficiently secure the core talent assets that drive innovation',
                    'Build a sustainable technology ecosystem in which talent and enterprises grow together'
                ]
            },
            vision: {
                label: 'VISION',
                title: 'Vision',
                quote: '"To become the global leader defining the standard for digital technology talent platforms"'
            },
            values: {
                label: 'VALUES',
                title: 'Values',
                items: ['Synergy', 'Focus', 'Innovation', 'Excellence', 'Win-Win']
            },
            greeting: {
                label: 'MESSAGE',
                title: 'President Message',
                paragraph1: 'Global aging is progressing rapidly, and many overseas markets are facing major demographic shifts and growing pressure on social services. In response to challenges such as population decline and low birthrate with aging, we are advancing a paradigm shift driven by the Fourth Industrial Revolution through the use of IoT and artificial intelligence. During my laboratory years, I studied knowledge related to artificial intelligence. I also gained multicultural experience through life with international students, learned how to build trust between people, and developed an international perspective.',
                paragraph2: 'In China, there is a phrase: "Putting people first and making the best use of every talent." People are the greatest asset of a company, so our management philosophy is to gather people, draw out their talents, and create value through people.',
                paragraph3: 'Starting from global market expansion, we will continue building an internationally influential artificial intelligence community and expand it to the world. The artificial intelligence technologies created through this community will contribute to society and enterprises.'
            },
            contact: {
                label: 'CONTACT',
                title: 'Contact Information',
                officeLabel: 'Tokyo Office',
                officeAddress: 'Nakada No.3 Building B1F, 3-7-6 Tabata Shinmachi, Kita-ku, Tokyo',
                phoneLabel: 'Phone',
                phone: '080-9981-0852',
                emailLabel: 'Email',
                email: 'contact@fw-robot.com',
                personLabel: 'Contact',
                person: '@Li Zengda',
                copyright: 'Copyright 2025 - Japan Mirai World Co., Ltd. All Rights Reserved.'
            }
        },
        ja: {
            hero: {
                kicker: 'About Us',
                title: 'ミライワールド',
                subtitle: 'ミライワールド / FUTURE WORLD',
                description: 'デジタル人材、日中人工知能コミュニティ運営、テクノロジー海外進出ワンストップサービス、スマート医療機器、スマートヘルスハードウェア製品の五大事業を展開するグローバルテクノロジーグループです。'
            },
            placeholders: {
                hero: '会社紹介メインビジュアル画像プレースホルダー',
                president: '社長写真プレースホルダー'
            },
            company: {
                subtitle: 'Company',
                title: '会社紹介',
                cardTitle: 'グローバルテクノロジーグループ',
                description: '未来世界（ミライワールド，FUTURE WORLD）は、デジタル人材、日中人工知能コミュニティ運営、テクノロジー海外進出ワンストップサービス、スマート医療機器、スマートヘルスハードウェア製品の五大事業を展開するグローバルテクノロジーグループです。'
            },
            business: {
                label: 'BUSINESS',
                items: [
                    'デジタル人材',
                    '日中人工知能コミュニティ運営',
                    'テクノロジー海外進出ワンストップサービス',
                    'スマート医療機器',
                    'スマートヘルスハードウェア製品'
                ]
            },
            strengths: {
                sectionLabel: 'TEAM & STRENGTH',
                sectionTitle: 'コアチームと海外市場経験',
                marketLabel: 'MARKET FOOTPRINT',
                marketTitle: 'チームのリソースと長期的な実務経験で越境展開を支えます',
                stats: [
                    { value: '10+', label: 'グローバル市場経験' },
                    { value: '100+', label: '提携サービスパートナー' },
                    { value: '1000+', label: '海外テクノロジー協業実績' },
                    { value: '100+', label: '標準化サービスモジュール' }
                ]
            },
            philosophy: {
                label: 'PHILOSOPHY',
                title: '経営理念',
                headline: 'AI-Solve：スマートに進化する未来のソリューション',
                formula: 'AI = AGI + Embedded Intelligence',
                description: '「汎用人工知能」と「具身知能」を中核とし、技術融合を通じてブレークスルーとなる価値を創造します。',
                solveItems: [
                    { key: 'S', title: 'Speed', desc: '技術変革に俊敏に対応する' },
                    { key: 'O', title: 'Opportunity', desc: '人材と企業の双方向の機会を築く' },
                    { key: 'L', title: 'Link', desc: 'グローバルなテクノロジーエコシステムをつなぐ' },
                    { key: 'V', title: 'Value', desc: '精密なマッチングによって多面的な価値向上を実現する' },
                    { key: 'E', title: 'Experience & Excellence', desc: '究極のサービス体験とプロフェッショナルとしての卓越性を追求する' }
                ]
            },
            mission: {
                label: 'MISSION',
                title: '使命',
                quote: '「テクノロジー人材に理想の仕事を、企業に最適な人材を」',
                items: [
                    'トップクラスのテクノロジー人材に理想のキャリアを実現するグローバルな舞台を提供する',
                    '企業がイノベーションを牽引する中核人材を効率的に獲得できるよう支援する',
                    '人材と企業がともに成長する持続可能なテクノロジーエコシステムを構築する'
                ]
            },
            vision: {
                label: 'VISION',
                title: 'ビジョン',
                quote: '「デジタルテクノロジー人材プラットフォームの基準を定義するグローバルリーダーになる」'
            },
            values: {
                label: 'VALUES',
                title: 'バリュー',
                items: ['聚力', '专注', '创新', '卓越', '共赢']
            },
            greeting: {
                label: 'MESSAGE',
                title: '社長挨拶',
                paragraph1: '全世界の高齢化は急速に進展しており、多くの海外市場で人口構造の変化や社会サービス高度化への対応が求められています。現在、人口減少や少子高齢化といった社会課題に対して、IoTや人工知能などを活用し、第4次産業革命によるパラダイムシフトを進めています。研究室時代には人工知能に関する知識を学び、また多国籍の仲間と共に過ごす中で異文化体験や人と人との信頼関係の築き方、国際的な視野を身につけました。',
                paragraph2: '中国では「以人为本，人尽其才」という言葉があります。人は会社の最大財産ですので、人の集まり、人の才能を引き出し、人の価値を生み出すという経営理念です。',
                paragraph3: '海外市場への展開を起点に、国際的な影響力を持つ人工知能コミュニティを構築し、世界へ広げていきます。人工知能コミュニティで生み出す人工知能技術は社会・企業に貢献していきます。'
            },
            contact: {
                label: 'CONTACT',
                title: '連絡先情報',
                officeLabel: '東京オフィス',
                officeAddress: '東京都北区田端新町3－７－６　中田第3ビルB1F',
                phoneLabel: '電話',
                phone: '080-9981-0852',
                emailLabel: 'メール',
                email: 'contact@fw-robot.com',
                personLabel: '担当者',
                person: '@李增达',
                copyright: 'Copyright 2025 - 株式会社日本ミライワールド All Rights Reserved.'
            }
        }
    }
};
